import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import SalesbotsIndex from './Index.vue';
import SalesbotsEditor from './Editor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/salesbots'),
      component: SettingsContent,
      props: {
        headerTitle: '',
        showBackButton: false,
      },
      children: [
        {
          path: '',
          name: 'salesbots_index',
          component: SalesbotsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':botId/edit',
          name: 'salesbots_editor',
          component: SalesbotsEditor,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
